import { useState } from "react";
import React from "react";
import "./style.scss";
import Dropdown from "@components/Dropdown";
import pluseImg from "./img/pluse.svg";
import minusImg from "./img/minuse.svg";

const formatDate = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleDateString("de-DE");
};

const formatMonthYear = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "-";

  return `${String(date.getMonth() + 1).padStart(2, "0")}.${date.getFullYear()}`;
};

const getOrdersCount = (orders) => {
  if (!orders || typeof orders !== "object") return 0;
  return Object.keys(orders).length;
};

export default function AboArchive({ aboData = [] }) {
  const [isOpen, setIsOpen] = useState(false);

  if (!aboData.length) return null;

  return (
    <div className="abo-archive">
      <Dropdown
        className="category"
        open={isOpen}
        setOpen={() => setIsOpen((prev) => !prev)}
        summary={
          <div className="category-wrapper">
            <h2 className="category-title">Abo-Archiv</h2>
            <img
              className="dropdown-image"
              alt="dropdown-image"
              src={isOpen ? minusImg : pluseImg}
            />
          </div>
        }
        details={
          <div className="list-content">
            <div className="list list-header">
              <div className="col id">#</div>
              <div className="col orders">Bestellungen</div>
              <div className="col start">Gestartet</div>
              <div className="col cancel">Gekündigt</div>
              <div className="col action"></div>
            </div>

            {aboData.map((item) => (
              <div className="list abo-row" key={item.uuid}>
                <div className="mobile-top">
                  <div className="col id">#{item.parentOrderId || "-"}</div>
                  <div className="col orders">
                    {getOrdersCount(item.orders)} Bestellungen
                  </div>
                </div>

                <div className="desktop-col col id">
                  {item.parentOrderId || "-"}
                </div>
                <div className="desktop-col col orders">
                  {getOrdersCount(item.orders)}
                </div>

                <div className="col start">
                  <span className="mobile-label">Gestartet:</span>{" "}
                  {formatDate(item.subscriptionStartDate)}
                </div>

                <div className="col cancel">
                  <span className="mobile-label">Gekündigt:</span>{" "}
                  {formatMonthYear(item.nextRenewalDate)}
                </div>

                <div className="col action">
                  <a
                    type="button"
                    className="details-link"
                    href="https://www.vuse.com/de/de/vorteils-abo/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Details ansehen
                  </a>
                </div>
              </div>
            ))}
            <a
              className="more-link"
              href="https://www.vuse.com/de/de/vorteils-abo/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mehr auf vuse.com
            </a>
          </div>
        }
      />
    </div>
  );
}
